import mapProps from '../scripts/utils/map-props';
import Cascader from './cascader';

export default mapProps(
  [
    'value',
  ],
  {
    model: {
      prop: 'value',
      event: 'change',
    },
  }
)(Cascader);
